import React from 'react';
import { MobileStepperProps as MuiMobileStepperProps, MobileStepper as MuiMobileStepper } from '@mui/material';

export interface MobileStepperProps extends Omit<MuiMobileStepperProps, 'backButton' | 'nextButton'> {
    backButton?: MuiMobileStepperProps['backButton'];
    nextButton?: MuiMobileStepperProps['nextButton'];
}

export function MobileStepper({ backButton = null, nextButton = null, ...props }: MobileStepperProps) {
    return <MuiMobileStepper backButton={backButton} nextButton={nextButton} {...props} />;
}
